import {
    Component,
    effect,
    EventEmitter,
    inject,
    Input,
    Output,
    signal,
} from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { Message } from 'primeng/message';
import { Tag } from 'primeng/tag';
import { GameVariantTemplate } from '@/lib-backend';
import { RealmGameVariantsService } from '@/app/services/realm-game-variants.service';
import {
    modeConfigTypeLabel,
    variantEntryFee,
    variantPlayerCount,
    variantTopReward,
} from '@/app/utils/variant';
import { resolveGameContentUrl } from '@/app/utils/game-content-url';
import { FundsDisplay } from '@/app/components/funds-display';

@Component({
    selector: 'app-add-variant-dialog',
    standalone: true,
    imports: [Button, Dialog, Message, Tag, FundsDisplay],
    templateUrl: './add-variant-dialog.html',
})
export class AddVariantDialog {
    @Input({ required: true }) set visible(v: boolean) {
        this.visibleSignal.set(v);
    }
    @Input({ required: true }) realmId = '';
    @Input({ required: true }) gameId = '';

    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() templateSelected = new EventEmitter<GameVariantTemplate>();

    protected readonly variantsService = inject(RealmGameVariantsService);

    protected readonly visibleSignal = signal(false);

    protected readonly modeConfigTypeLabel = modeConfigTypeLabel;
    protected readonly variantPlayerCount = variantPlayerCount;
    protected readonly variantEntryFee = variantEntryFee;
    protected readonly variantTopReward = variantTopReward;
    protected readonly resolveGameContentUrl = resolveGameContentUrl;

    constructor() {
        effect(() => {
            if (this.visibleSignal() && this.realmId && this.gameId) {
                this.variantsService.loadTemplates(this.realmId, this.gameId);
            }
        });
    }

    protected onVisibleChange(value: boolean): void {
        this.visibleSignal.set(value);
        this.visibleChange.emit(value);
    }

    protected close(): void {
        this.onVisibleChange(false);
    }

    protected pick(t: GameVariantTemplate): void {
        this.templateSelected.emit(t);
        this.close();
    }

    protected trackById(_index: number, t: GameVariantTemplate): string {
        return t.GameVariantTemplateId;
    }
}
